import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Title from 'components/landing/shared/Title'
import Caption from 'components/landing/shared/Caption'
import Button from 'components/util/Button'
import styles from './_mid2018Victories.css'
import { AD_SIZES } from 'services/ads/constants'
import Ad from 'components/util/ads/Ad'
import ResponsiveImage from 'components/util/ResponsiveImage'

import whiteLogo from 'images/year-in-review/2018/midyear/afi/white.png'
import colorLogo from 'images/year-in-review/2018/midyear/afi/color.png'

function Victories (props) {
  const { showSponsor } = props

  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const adSize = isMobile ? AD_SIZES.RAIL_2 : AD_SIZES.BANNER_1

  const handleCta = () => {
    window.location.href = 'https://blog.myfitnesspal.com/victory/'
  }
  return (
    <div className={styles.victoriesWrapper}>
      <div className={styles.victories}>
        <div className={styles.content}>
          <Title
            className={styles.title}
            color='white'
          >
            <FormattedMessage
              id='midyear.2018.victories.title'
              defaultMessage={'Thousands of victories achieved... and counting'}
            />
          </Title>
          <Caption>
            <FormattedMessage
              id='midyear.2018.victories.subhead'
              defaultMessage={`Our community set goals.\nThen crushed them.`}
            />
          </Caption>
          <Caption>
            <FormattedMessage
              id='midyear.2018.victories.caption'
              defaultMessage={'Congratulations! It\'s time to celebrate the wins. You worked for them. Keep it up, tell your story, and motivate each other to continue to hit goals.'}
            />
          </Caption>
          <Button className={styles.cta} size="medium" type="default" onClick={handleCta}>
            <FormattedMessage id='midyear.2018.victories.cta' defaultMessage='See Victory Stories' />
          </Button>
        </div>
        <div className={styles.media}>
          <iframe src="//players.brightcove.net/5415335156001/default_default/index.html?videoId=5799740038001"
            className={styles.video}
            allowFullScreen
            webkitallowfullscreen
            mozallowfullscreen
          />
          { showSponsor ?
            <div className={styles.byline}>
              <ResponsiveImage medium={whiteLogo} src={colorLogo} />
            </div>
          : null }
        </div>
      </div>
      { showSponsor ?
        <div className={styles.adWrapper}>
          <Ad
            customAdUnit='/17729925/UACF_W/MMF/MMF_Blog/Mid_Year_Review'
            sizes={[adSize]}
          />
        </div>
      : null }
    </div>
  )
}

Victories.propTypes = {
  showSponsor: PropTypes.bool,
}

export default Victories



// WEBPACK FOOTER //
// ./src/components/yearInReview/2018/midyear/Victories/index.js